export const dateParser = (inputDateString: string): string => {
    const months = [
        'enero',
        'febrero',
        'marzo',
        'abril',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'septiembre',
        'octubre',
        'noviembre',
        'diciembre'
    ]

    const dateParts = inputDateString.split(/[- :]/)
    const year = parseInt(dateParts[0])
    const month = parseInt(dateParts[1]) - 1
    const day = parseInt(dateParts[2])

    const formattedDate = `${day} de ${months[month]} ${year}`

    return formattedDate
}
